import { Button, Group, Modal, Text } from '@mantine/core'

interface ConfirmChangesModalProps {
  title: string
  description: string
  opened: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}

export function ConfirmChangesModal({
  title,
  description,
  opened,
  isLoading,
  onClose,
  onConfirm,
}: ConfirmChangesModalProps) {
  return (
    <Modal.Root opened={opened} onClose={onClose} centered>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Text size="sm">{description}</Text>
          <Group justify="flex-end" mt="xl">
            <Button variant="light" onClick={onClose}>
              Cancel
            </Button>
            <Button onClick={onConfirm} loading={isLoading}>
              Confirm Changes
            </Button>
          </Group>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
